import React from "react";

interface Subject {
  _id: string;
  title: string;
}

interface SubjectSelectorProps {
  subjects: Subject[];
  selectedSubjects: Subject[];
  onSelect: (subjects: Subject[]) => void;
}

const MultiSubjectSelector: React.FC<SubjectSelectorProps> = ({
  subjects,
  selectedSubjects,
  onSelect,
}) => {
  const isSelected = (id: string) => {
    return selectedSubjects.some((subj) => subj._id === id);
  };

  const handleToggle = (subject: Subject) => {
    if (isSelected(subject._id)) {
      onSelect(selectedSubjects.filter((s) => s._id !== subject._id));
    } else {
      onSelect([...selectedSubjects, subject]);
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full">
      {subjects.map((subject) => {
        const selected = isSelected(subject._id);
        return (
          <div
            key={subject._id}
            className={`flex items-stretch rounded-md overflow-hidden transition-all duration-200 border ${
              selected ? "border-red-500" : "border-gray-300"
            }`}
          >
            {!selected && (
              <button
                onClick={() => handleToggle(subject)}
                className="bg-gray-300 text-red-500 px-3 py-2 text-2xl"
              >
                +
              </button>
            )}

            <div className="flex-1 bg-white px-4 py-2 flex items-center justify-between">
              <span className="text-gray-800 font-medium">{subject.title}</span>
            </div>

            {selected && (
              <button
                onClick={() => handleToggle(subject)}
                className="bg-red-200 px-3 py-2 text-red-500 text-2xl"
              >
                −
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MultiSubjectSelector;
